module.exports = __webpack_public_path__ + "static/media/21b-01-HOME_ST-2021-188x2375mm-oleo-sobre-tela.30ca385b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/21b/21b-01-HOME_ST-2021-188x2375mm-oleo-sobre-tela.jpg
// module id = 256
// module chunks = 0